import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const DeviceIcon = ({ type = 'brand', size = 'regular', styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { width: sizePx, height: sizePx, viewBox: "0 0 24 42", style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M-1069-1282H371V879h-1440z" }),
            React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round" },
                React.createElement("path", { d: "M15.667 19.667a4 4 0 11-8 0 4 4 0 018 0zM7.667 31.048c0-.395 1.79-.715 4-.715 2.209 0 4 .32 4 .715M7.667 31.286l.93 4.39c0 .261 1.4.61 3.127.61 1.727 0 3.127-.349 3.127-.61l.816-4.39" }),
                React.createElement("path", { d: "M1 2.252V39.35S3.31 41 6.198 41H16.65s3.408.016 5.682-1.537V1.74S17.622 1 16.005 1H7.11S3.946 1 1 2.252z" }),
                React.createElement("path", { d: "M7.667 10.333h8v-4h-8z" })))));
};
export default DeviceIcon;
//# sourceMappingURL=index.js.map